import React, { PropTypes } from 'react';
import { NitroHeading, NitroSingleSelect } from 'nitro-components';
import styled from 'styled-components';

import withSelected from '../hoc/withSelected';

const DropDownWrapper = styled.div`
  position: static;
  z-index: 0;
  margin-bottom: 50px;
`;

const DropdownSelectGroup = ({
  termId,
  label,
  data,
  clickHandler,
  selected,
  disabled,
  ...props
}) => {

  const fuelCardOptions = data.map(({ key, Value }) => ({
    label: Value,
    value: key,
  }));

  /**const options = [{
    label: 'Please select...',
    value: null,
  }, ...fuelCardOptions];**/
  const options = [
   ...fuelCardOptions];

  const selectedOption = selected && options.filter(option => option.value === selected.key)[0];

  return (

    (
      <DropDownWrapper>

        <NitroHeading size="2" align="left" label={label} noMargin />

        <NitroSingleSelect
          id="dropdown-select-group"
          value={selectedOption && selectedOption.value}
          autoWidth
          placeholder={`Please select...`}
          disabled={disabled}
          action={({ label, value }) => clickHandler({
            termId,
            key: value,
            Value: label,
            componentType: 'DropdownSelectGroup'
          })}
          options={options}
          containerMaxHeight="150px"
        />
      </DropDownWrapper>
    )
  );
};

DropdownSelectGroup.propTypes = {
  termId: PropTypes.string,
  data: PropTypes.array,
  clickHandler: PropTypes.func,
  label: PropTypes.string,
  style: PropTypes.object,
  selected: PropTypes.object,
  disabled: PropTypes.bool
};

export default withSelected(DropdownSelectGroup);



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/components/DropdownSelectGroup.js